import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./app";
import { ToastProvider } from "@/components/toast";
import { ConfirmProvider } from "@/components/confirm";
import { applyTheme, storedTheme } from "@/lib/theme";
import "./styles.css";
import "./app.css";
import "./theme.css";
import "./design-system.css";

// Applied before the first render so the app never flashes the wrong palette.
applyTheme(storedTheme());

const queryClient = new QueryClient({
  defaultOptions: {
    // Client errors (401/403/404/422) will not become successes on a retry —
    // retrying them only delayed the message the user needs to see.
    queries: {
      staleTime: 30_000,
      retry: (count, error) => {
        const status = error instanceof Error && "status" in error ? (error as { status: number }).status : 0;
        if (status >= 400 && status < 500) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
